import React from "react";
import { InputField, SelectField } from "../../components/ui/UIComponents";

// ─────────────────────────────────────────────────────────────────────────────
// STEP 2 — Education Details
// ─────────────────────────────────────────────────────────────────────────────

const QUALIFICATIONS = [
  "SSLC (10th)", "PUC (12th)", "Diploma", "ITI",
  "B.E / B.Tech", "B.Sc / BCA / BCS", "BBA / B.Com / BA",
  "MCA / M.Tech / M.E", "MBA", "PhD", "Other",
];

const BRANCHES = [
  "Computer Science Engineering",
  "Information Science Engineering",
  "Electronics & Communication",
  "Electrical Engineering",
  "Mechanical Engineering",
  "Civil Engineering",
  "Data Science",
  "AI & Machine Learning",
  "BCA / Computer Applications",
  "BSc Computer Science",
  "Commerce / Business",
  "Arts / Humanities",
  "Science (PCM / PCB)",
  "Other",
];

const YEARS = Array.from({ length: 10 }, (_, i) => String(new Date().getFullYear() - i));

const getGradeColor = cgpa => {
  const val = parseFloat(cgpa);
  if (!val) return null;
  if (val >= 9)   return "#10b981";
  if (val >= 8)   return "#22d3ee";
  if (val >= 7)   return "#3b82f6";
  if (val >= 6)   return "#f59e0b";
  return "#ef4444";
};

export default function Step2Education({ form, setForm }) {
  const update = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const gradeColor = getGradeColor(form.cgpa);

  const gradeLabel = (() => {
    const v = parseFloat(form.cgpa);
    if (!v) return null;
    if (v >= 9)   return "Outstanding — Top Tier";
    if (v >= 8)   return "Excellent — Strong Profile";
    if (v >= 7)   return "Good — Solid Academic Record";
    if (v >= 6)   return "Average — Boost with Skills";
    return "Below Average — Focus on Skills";
  })();

  return (
    <div>
      {/* Qualification */}
      <SelectField
        label="Highest Qualification" required
        value={form.qualification}
        onChange={v => update("qualification", v)}
        options={QUALIFICATIONS}
      />

      {/* Branch / Course */}
      <SelectField
        label="Branch / Course Name" required
        value={form.courseName}
        onChange={v => update("courseName", v)}
        options={BRANCHES}
      />

      {/* College Name */}
      <InputField
        label="College / School Name"
        value={form.collegeName}
        onChange={v => update("collegeName", v)}
        placeholder="e.g. VTU College of Engineering"
      />

      {/* University */}
      <InputField
        label="University / Board"
        value={form.university}
        onChange={v => update("university", v)}
        placeholder="e.g. Visvesvaraya Technological University"
      />

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        {/* Year */}
        <SelectField
          label="Year of Completion"
          value={form.yearCompletion}
          onChange={v => update("yearCompletion", v)}
          options={["2026 (Expected)", ...YEARS]}
        />

        {/* CGPA */}
        <div>
          <InputField
            label="CGPA / Percentage"
            value={form.cgpa}
            onChange={v => update("cgpa", v)}
            placeholder="e.g. 8.5 or 78%"
          />
          {/* Grade label */}
          {gradeColor && (
            <div style={{
              marginTop: -10, marginBottom: 14,
              padding: "6px 12px",
              background: `${gradeColor}12`,
              border: `1px solid ${gradeColor}35`,
              borderRadius: 6,
              fontSize: 12,
              color: gradeColor,
              fontFamily: "Rajdhani, sans-serif",
              fontWeight: 600,
              letterSpacing: 0.5,
            }}>
              ● {gradeLabel}
            </div>
          )}
        </div>
      </div>

      {/* Backlogs */}
      <SelectField
        label="Active Backlogs / Arrears"
        value={form.backlogs}
        onChange={v => update("backlogs", v)}
        options={["None (Clean Record)","1–2 Backlogs","3–5 Backlogs","6+ Backlogs"]}
        hint="Recruiters may consider this during shortlisting"
      />

      {/* Mode */}
      <SelectField
        label="Mode of Study"
        value={form.studyMode}
        onChange={v => update("studyMode", v)}
        options={["Regular / Full-Time","Part-Time","Distance / Correspondence","Online Degree"]}
      />
    </div>
  );
}